import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import NextHead from 'next/head';
import { useRouter } from 'next/router';

import SETTINGS from '../../settings';

const HEAD_KEY = {
  GTAG: 'gtag',
  GTAG_SCRIPT: 'gtagScript',
  FBQ: 'fbq',
};

const Scripts = props => {
  const timeout = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const router = useRouter();

  useEffect(() => {
    timeout.current = setTimeout(() => {
      props.onAppInit();
      setIsLoaded(true);
    }, 2000);

    return () => {
      clearTimeout(timeout.current);
    };
  }, []);

  useEffect(() => {
    if (isLoaded && props.onPageView) {
      props.onPageView(router.asPath);
    }
  }, [isLoaded, props.onPageView, router.asPath]);

  if (!isLoaded) {
    return null;
  }

  return (
    <NextHead>
      <script
        key={HEAD_KEY.GTAG}
        type="text/javascript"
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${SETTINGS.SCRIPTS.GTAG_ID}`}
      />

      <script
        key={HEAD_KEY.GTAG_SCRIPT}
        type="text/javascript"
        async
        dangerouslySetInnerHTML={{
          __html: `
            if (!window.gtag) {
            window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${SETTINGS.SCRIPTS.GTAG_ID}');
            }`,
        }}
      />

      <script
        key={HEAD_KEY.FBQ}
        type="text/javascript"
        async
        dangerouslySetInnerHTML={{
          __html: `
            if (!window.fbq) {
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${SETTINGS.SCRIPTS.FACEBOOK_PIXEL_ID}');
            }`,
        }}
      />
    </NextHead>
  );
};

Scripts.propTypes = {
  onAppInit: PropTypes.func,
  onPageView: PropTypes.func,
};

Scripts.defaultProps = {
  onAppInit: () => {},
  onPageView: () => {},
};

export default Scripts;
